module.exports = __webpack_public_path__ + "./images/31a888cd4e26d321ced119561e3fda5e.webp";